import { styled } from '@mui/material'

export const FieldLabel = styled('label')`
    margin-bottom: 3px;
    display: block;
    font-size: 14px;
    font-weight: 500;
`
